<template>
    <div class="topLogo">
        <el-row type="flex">
            <el-col :xs="5" :sm="5" :md="4" :lg="4" class="systemNameBox">
                <div class="leftLogo flex flex-align-center flex-pack-center">
                    <img src="../../assets/index/logo_title.png"  alt="">
                </div>
            </el-col>
            <el-col :xs="13" :sm="13" :md="17" :lg="17" class="crumbsBox">
                <div class="search flex flex-align-center crumbs_class" >
                    <div class="scroll-x-wrap" id="scroll-x">
                        <span :class="nowTabPath==item.path?'item active':'item'" v-for="(item,index) in tabNamesList" :key="index" @click.stop="toThisTab(item)">
                            <b>{{item.meta.tabName}}<i class="iconfont icon-guanbi" @click.stop="closeTab(item)"></i></b>
                        </span>
                    </div>
                </div>
            </el-col>
            <el-col :xs="2" :sm="2" :md="1" :lg="1" class="msgCenterBox">
                <div class="msgCenter flex flex-align-center flex-pack-center" v-if='tabNamesList.length>5'>
                    <span class="arrow">
                        <i class="iconfont icon-Arrowleftback" @click="toScrollX('left')"></i>
                        <i class="iconfont icon-Arrowrightnext" @click="toScrollX('right')"></i>
                    </span>
                    <!-- <div class="msgCenterImg">
                        <img src="../../assets/index/msgCenter.png" alt="msgCenter">
                    </div> -->
                </div>
            </el-col>
            <el-col :xs="2" :sm="2" :md="1" :lg="1" class="traggerSideBar">
                <div class="listMenu flex flex-align-center flex-pack-center">
                    <div class="listMenuImg" >
                        <img src="../../assets/index/listMenu.png" alt="listMenu">
                    </div>
                </div>
            </el-col>
            <el-col :xs="2" :sm="2" :md="1" :lg="1" class="selfCenterBox">
                <div class="selfCenter flex flex-align-center flex-pack-center">
                    <div class="headImg" @click.stop="$emit('changeSelfCenter', selfCenterBtn);" title="个人中心">
                        <i class="iconfont icon-gerenzhongxin"></i>
                    </div>
                    <div class="selfCenterCon" :style="{display:(selfCenterBtn?'block':'none')}" @click.stop="">
                        <div class="title">个人中心</div>
                        <div class="msgItem clearfix">
                            <span class="left itemName">店铺名称：</span>
                            <span class="left itemVal" v-text="storeData.name"></span>
                        </div>
                        <div class="msgItem clearfix">
                            <span class="left itemName">地理位置：</span>
                            <span class="left itemVal" v-text="storeData.addr"></span>
                        </div>
                        <div class="msgItem clearfix">
                            <span class="left itemName">创建时间：</span>
                            <span class="left itemVal">{{storeData.addTime | numberToDate('')}}</span>
                        </div>
                        <div class="msgItem clearfix">
                            <span class="left itemName">登录帐号：</span>
                            <span class="left itemVal" v-text="username"></span>
                        </div>
                        <div class="btnGroup">
                            <button type="button" @click="logout">退出登录</button>
                        </div>
                    </div>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script type="text/javascript">
    import {url} from '@/router/url.js';
    export default{
        props:['crumbs', 'storeData', 'openSelfCenter','tab'],
    	data () {
    		return {
                tabNamesList:[],
                nameTree:'',
                selfCenterBtn: false,
                username: '', // 当前登录帐号
                nowTabPath:'',
    		}
    	},
        watch:{
            crumbs(val){
                this.crumbsFn(val)
            },
            openSelfCenter ( val ) {
                this.selfCenterBtn = val;
            },
            tab(val){
                let tabNamesList = [];
                if(JSON.parse(sessionStorage.getItem("tabNames"))){
                    tabNamesList = JSON.parse(sessionStorage.getItem("tabNames"));
                }
                this.tabNamesList = tabNamesList;
                this.nowTabPath = this.$route.path
            }
        },
        methods: {
            toScrollX(type){
                let scrollX = $("#scroll-x").scrollLeft();
                if(type=='left'){
                    $("#scroll-x").scrollLeft(scrollX-200);
                }else{
                    $("#scroll-x").scrollLeft(scrollX+200);
                }
            },
            toThisTab(item){
                this.$router.push({path:item.path});
            },
            closeTab(item){
                let tabNamesList = JSON.parse(sessionStorage.getItem("tabNames"));
                let index = -1;
                for(let i = 0;i<tabNamesList.length;i++){
                    if(tabNamesList[i].meta.tabName == item.meta.tabName){
                        index = i;
                    }
                }
                tabNamesList.splice(index,1);
                console.log(tabNamesList)
                this.tabNamesList = tabNamesList;
                sessionStorage.setItem("tabNames",JSON.stringify(tabNamesList));
            },
            showSideBar: function () {
                this.$emit('showSideBar', true);
            },
            goHome: function () {
                this.$router.push({path:'./home'});
            },
            // 退出登录
            logout: function () {
                this.$http.post('/logout', {}).then((res)=>{
                    localStorage.clear();
                    sessionStorage.clear();
                    this.$router.push({path:'/login'});
                }).catch((err)=>{

                })
            },
            crumbsFn(value){
                let nameTree = '';
                switch(true){
                    case value == 'Statement'          : nameTree = "<i class='iconfont icon-shouye'></i><span>交易趋势</span>"                              ;break;
                    case value == 'statement'     : nameTree = "<i class='iconfont icon-dianpufenxi'></i><span>店铺报表</span>"                     ;break;
                    case value == 'employee'      : nameTree = "<i class='iconfont icon-admin_man'></i><span>员工管理 > 员工列表</span>"            ;break;
                    case value == 'achievement'   : nameTree = "<i class='iconfont icon-admin_man'></i><span>员工管理 > 员工业绩</span>"            ;break;
                    case value == 'jobs'          : nameTree = "<i class='iconfont icon-gangweibiandong'></i><span>岗位管理 > 岗位</span>"          ;break;
                    case value == 'lostVip'        : nameTree = "<i class='iconfont icon-huiyuanguanli'></i><span>会员管理 > 会员资料</span>"        ;break;
                    case value == 'vipCons'       : nameTree = "<i class='iconfont icon-huiyuanguanli'></i><span>会员管理 > 会员消费记录</span>"    ;break;
                    case value == 'vipRecharge'   : nameTree = "<i class='iconfont icon-huiyuanguanli'></i><span>会员管理 > 会员充值规则</span>"    ;break;
                    case value == 'goodsInfo'     : nameTree = "<i class='iconfont icon-shangpinguanli'></i><span>商品管理 > 商品资料</span>"       ;break;
                    case value == 'goodsClassify' : nameTree = "<i class='iconfont icon-shangpinguanli'></i><span>商品管理 > 商品分类</span>"       ;break;
                    case value == 'goodsInterval' : nameTree = "<i class='iconfont icon-shangpinguanli'></i><span>商品管理 > 销售时段管理</span>"       ;break;
                    case value == 'dailyGrade'  : nameTree = "<i class='iconfont icon-shujufenxi'></i><span>对账单</span>"                    ;break;
                    case value == 'exchangeWork'  : nameTree = "<i class='iconfont icon-shujufenxi'></i><span>交接班记录</span>"                    ;break;
                    case value == 'staffGrade'  : nameTree = "<i class='iconfont icon-shujufenxi'></i><span>对账单</span>"                    ;break;
                    case value == 'orderSearch'   : nameTree = "<i class='iconfont icon-shujufenxi'></i><span>订单流水"+
                    "<span style='color:red'>（检索订单必须有起止时间，每次导出数据控制在10000条以内!）</span></span>"                    ;break;
                    case value == 'totalSales'    : nameTree = "<i class='iconfont icon-shujufenxi'></i><span>销售汇总</span>"                    ;break;
                    case value == 'stockSummary'    : nameTree = "<i class='iconfont icon-shujufenxi'></i><span>采购汇总</span>"                    ;break;
                    case value == 'invList'       : nameTree = "<i class='iconfont icon-kucun'></i><span>库存管理 > 入库记录</span>"           ;break;
                    case value == 'invAdd'        : nameTree = "<i class='iconfont icon-kucun'></i><span>库存管理 > 商品入库</span>"           ;break;
                    case value == 'invDetails'    : nameTree = "<i class='iconfont icon-kucun'></i><span>库存管理 > 库存详情</span>"           ;break;
                    case value == 'merCert'       : nameTree = "<i class='iconfont icon-ecmerchants'></i><span>商户资料 >商户认证"+
                    "<span style='color:red'></span></span>"              ;break;
                    case value == 'keyCert'       : nameTree = "<i class='iconfont icon-ecmerchants'></i><span>商户资料 >秘钥认证</span>"+
                    "<span style='color:red'>（您的资料提交后会收到来自13980547109(微信同号)的电话确认，请您放心接听!）</span></span>"              ;break;
                    case value == 'createCode'    : nameTree = "<i class='iconfont icon-qrcode'></i><span>下载中心</span>"                        ;break;
                    case value == 'topUp'         : nameTree = "<i class='iconfont icon-xufei'></i><span>充值中心</span>"                           ;break;
                    case value == 'setting'       : nameTree = "<i class='iconfont icon-set'></i><span>系统设置</span>"                             ;break;
                    case value == 'addcoupon'     : nameTree = "<i class='iconfont icon-youhuiquan'></i><span>优惠券管理 > 创建中心</span>"                    ;break;
                    case value == 'couponDetail'  : nameTree = "<i class='iconfont icon-youhuiquan'></i><span>优惠券管理 > 派发记录</span>"                    ;break;
                    case value == 'voiceCall'  : nameTree = "<i class='iconfont icon-yuyin'></i><span>语音呼叫</span>"                    ;break;
                    case value == 'rewardInfo'  : nameTree = "<i class='iconfont icon-shujufenxi'></i><span>打赏记录</span>"                    ;break;
                    case value == 'ratingInfo'  : nameTree = "<i class='iconfont icon-shujufenxi'></i><span>评价记录</span>"                    ;break;
                    case value == 'getWithdraw'  : nameTree = "<i class='iconfont icon-shujufenxi'></i><span>提现记录</span>"                    ;break;
                    case value == 'putWithdraw'  : nameTree = "<i class='iconfont icon-shujufenxi'></i><span>我要提现</span>"                    ;break;
                    case value == 'setWithdraw'  : nameTree = "<i class='iconfont icon-shujufenxi'></i><span>提现信息</span>"                    ;break;
                    case value == 'market'  : nameTree = "<i class='iconfont icon-shangcheng'></i><span>原料商城</span>"                    ;break;
                };
                this.nameTree = nameTree;
            }
        },
        created(){
            this.crumbsFn(this.$route.name);
            this.username = localStorage.getItem('username');
            let tabNamesList = [];
            if(JSON.parse(sessionStorage.getItem("tabNames"))){
                tabNamesList = JSON.parse(sessionStorage.getItem("tabNames"));
            }
            this.tabNamesList = tabNamesList;
        }
    }
</script>
<style lang="scss">
    @import '../../../static/css/common.scss';
	@import "topLogo";
</style>



// WEBPACK FOOTER //
// topLogo.vue?5ddd07c4